import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { api_host } from '../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {Chip, Popover, Grid} from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/es';
import { updateObjetivos } from '../../../../services/tags';
import { useState } from 'react';
import ChipTag from '../../../../components/TagsAtentus/ChipTag';

import ManageObjective from '../ManageObjective';
// Component styles
import styles from './styles';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class ListObjectives extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            values: {

            },
            open: false,
            isValid: false,
            validEmail: false,
            validName: false,
            //isRefresh: this.props.params.isRefresh,
            listObjectives: this.props.objectivesList
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
      this.processData(this.state.listObjectives);
    }

    componentDidUpdate(prevProps, prevState) {}
    componentWillUnmount() {}

   

    // Helper para procesar la data de la petición a la API

    processData = () => {
        const {listObjectives} = this.state

        let arrayRowsObjectives = []
        let intervals = []
        let token = sessionStorage.getItem('key')
        Promise.all([
            fetch(api_host+`/reporte/general/intervalos_y_zona_horaria/?token=${token}&start=${new Date().getTime()}`)
        ])
            .then(([res1]) => {
                return Promise.all([res1.json()])
            })
            .then(([res1]) => {
                intervals = res1
                Object.keys(listObjectives).map((key0)=> {
                    let arrayObjetives = listObjectives[key0]
                    if (key0 != 'Services' && key0 != 'ServicesUnified') {
                        Object.keys(arrayObjetives).map((key1)=> { 
                            let rows = {}
                            rows['id'] = arrayObjetives[key1].objetivo_id
                            rows['nombre'] = arrayObjetives[key1].nombre  
                            rows['descripcion'] = arrayObjetives[key1].descripcion  
                            rows['servicio'] = arrayObjetives[key1].nombre_servicio_unificado  
                            rows['intervalo'] = arrayObjetives[key1].intervalo  
                            rows['intervalo_id'] = arrayObjetives[key1].intervalo_id 
                            rows['servicio_id'] = arrayObjetives[key1].servicio_id
                            rows['nodos'] = arrayObjetives[key1].Nodos
                            rows['pasos'] = arrayObjetives[key1].Pasos
                            rows["etiquetas"] = arrayObjetives[key1].Etiquetas ?? [];
                            arrayRowsObjectives.push(rows)
                        })
                    }   
                })
                this.setState({
                    //rows : arrayRows,
                    rows: arrayRowsObjectives,
                    intervals: res1, 
                    //noMonCum : noMonCumDate,
                    //downCum : downCumDate,
                    isLoading: false,
                    //time: period,
                    //step: step,
                    dataError: false,
                }); 
            }); 
       
    }
    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            values:{
                type: 2,
            }
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            values:{
                descriptionEdit: value.descripcion,
                intervalEdit: value.intervalo,
                serviceEdit: value.servicio,
                nameEdit: value.nombre,
                objidEdit: value.id,
                serviceidEdit: value.servicio_id,
                intervalidEdit: value.intervalo_id,
                nodesEdit: value.nodos,
                stepEdit: value.pasos,
                etiquetas: value.etiquetas
            }
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };
    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };


    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
        open: false,
      });
    };

    updateList = async () => {
      const data = await updateObjetivos();
      this.setState({ listObjectives: data });
      this.processData(data);
      // this.props.history.push({pathname: '/manageObjectives', search: getQueryParams()})
    };

    render() {
    const { classes, className, t, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, deleteEl, open, isValid, validEmail, validName, values, intervals} = this.state;
        const {destinyEdit, nameEdit, phoneEdit, typeEdit, name } = this.state.values
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);
        const showEditEl = Boolean(editEl);
        const showDeleteEl = Boolean(deleteEl);
  
        if (!dataError) {
            return (
              <FormattedChart t={t} classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                handleCloseAdd={this.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                handleFieldChange={this.handleFieldChange}
                handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                destinyEdit={destinyEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                handleDeleted={this.handleDeleted} 
                open={open} isValid={isValid} handleClose={this.handleClose}
                handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                name={name} validEmail={validEmail} validateEmail={this.validateEmail} 
                validName={validName} validateName={this.validateName}
                values={values} intervals={intervals} updateList={() => this.updateList()}
              />) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

export function ChipVerMas({etiquetas, length}) {
  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <div style={{padding: 2}}>
      <Chip
        id="etiquetas"
        label={`+ ${etiquetas.length - length}...`}
        style={{
          backgroundColor: "white",
          color: "black",
          borderRadius: 3,
        }}
        size="small"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => setAnchorEl(null)}
      >
        <div style={{
          minHeight: 40,
          backgroundColor: "#f0f0f0",
          borderStyle: "solid",
          borderColor: "#e0e0e0",
          borderWidth: 1,
          display: "flex",
          padding: 6,
          flexWrap: "wrap",
          maxWidth: 670,
          flexDirection: "column"
        }}>
          {
            etiquetas.slice(length).map(item => (
              <div key={item.etiqueta_id} style={{padding: 2}}>
                <ChipTag nombre={item.nombre} color={item.color} />
              </div>
            ))
          }
        </div>
      </Popover>
    </div>
  )
}

function FormattedChart(props) {
  const { t } = props
  return (
    <div>
      { props.rows == null  ? 
        <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
            <CircularProgress variant="indeterminate" size={24} thickness={4} />
          </Grid>
          <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
              {t('listObjectives.loadingInformation')}
          </Grid>
        </Grid>
      :
        <div style={{ maxWidth: "100%", marginTpo:'105px'  }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                    <MaterialTable
                        icons={tableIcons}
                        columns={[
                            { width: 100, title: t('listObjectives.table.nombre'), field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                            { width: 100, title: t('listObjectives.table.descripcion'), field: "descripcion" ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                            { width: 100, title: t('listObjectives.table.servicio'), field: "servicio"/*, type: "numeric"*/ ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                              {
                                width: 20,
                                field: 'etiquetas',
                                title: t('listObjectives.table.etiquetas'),
                                render: rowData => (
                                  <div style={{display: "flex", flexDirection: "row"}}>
                                    {
                                      (rowData.etiquetas && rowData.etiquetas.length) ? 
                                      <>
                                        {
                                          rowData.etiquetas.slice(0, 3).map(item => (
                                            <div style={{padding: 2}}>
                                              <ChipTag nombre={item.nombre} color={item.color} />
                                            </div>
                                          ))
                                        }
                                        {rowData.etiquetas.length > 3 ? 
                                          <ChipVerMas etiquetas={rowData.etiquetas} size="small" length={3} />
                                        : null}
                                      </>
                                      : null
                                    }
                                  </div>
                                )
                              },
                            { width: 100, title: t('listObjectives.table.editar'), field: "editar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: t('listObjectives.table.intervalo'), field: "intervalo"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: t('listObjectives.table.intervalo_id'), field: "intervalo_id"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#039be5',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: t('listObjectives.table.nodos'), field: "nodos"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true },
                            { width: 100, title: t('listObjectives.table.pasos'), field: "pasos"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true },
                            
                        ]}
                        data={props.rows} 
                        title=" "
              localization={{
              grouping: {
                groupedBy: t('listObjectives.localization.groupedBy'),
                placeholder: t('listObjectives.localization.groupingPlaceholder'),
              },
              body: {
                emptyDataSourceMessage: t('listObjectives.localization.body.emptyDataSourceMessage')
              },
              toolbar: {
                searchTooltip: t('listObjectives.localization.toolbar.searchTooltip'),
                searchPlaceholder: t('listObjectives.localization.toolbar.searchPlaceholder')
              },
              pagination: {
                labelRowsSelect: t('listObjectives.localization.pagination.labelRowsSelect'),
                labelDisplayedRows: t('listObjectives.localization.pagination.labelDisplayedRows'),
                firstTooltip: t('listObjectives.localization.pagination.firstTooltip'),
                previousTooltip: t('listObjectives.localization.pagination.previousTooltip'),
                nextTooltip: t('listObjectives.localization.pagination.nextTooltip'),
                lastTooltip: t('listObjectives.localization.pagination.lastTooltip')
              },
              header: {
                actions: '',
                headerStyle: {
                  backgroundColor: '#e7e7e7',
                  color: '#FFF'
                }
              },
            }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
              actions={[
              {
                icon: Edit,
                tooltip: t('listObjectives.actions.editTooltip'),
                onClick: (event, rowData) => props.handleShowEdit(event, rowData)
              },
            ]}
                    />
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showEditEl}
                        onClose={props.handleCloseEdit}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showEditEl} style={{maxWidth: 700}}>
                            <div className={props.classes.modal}>    
                                {<ManageObjective values={props.values} intervals={props.intervals} handleCloseEdit={props.handleCloseEdit} updateList={props.updateList}></ManageObjective>}                                              
                            </div>
                        </Fade>
                    </Modal>
    
                    
                </div>
                
            }
            </div>
        )

}

export default compose(withRouter, withStyles(styles), withTranslation())(ListObjectives);
